import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import templateService from "../../../services/template.service";
import { toast } from "react-toastify";
import VoiceSequence from "./VoiceSequence";
import Loading from "../../common/Loading";

function ClinicEditCallTemplate() {
  const { clinicId, templateId } = useParams();
  const [template, setTemplate] = useState(null);
  const [txtContent, setTxtContent] = useState(null);
  const [txtVoiceSequence, setTxtVoiceSequence] = useState([]);
  const [txtStatus, setTxtStatus] = useState(1);
  const [txtAudioPath, setTxtAudioPath] = useState(null);
  const [loading,setLoading] = useState(false);

  const navigate = useNavigate();
  const [newItem, setNewItem] = useState({
    type: "Static",
    content: "",
    path: null,
  });

  const getClinicCallTemplate = useCallback(() => {
    templateService
      .getCallTemplateById(clinicId, templateId)
      .then((res) => {
        setTxtContent(res.data.content);
        setTxtVoiceSequence(res.data.voiceSequence);
        setTxtStatus(res.data.status);
        setTxtAudioPath(res.data.audioPath);
        setTemplate(res.data);
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  }, [clinicId, templateId]);

  useEffect(() => {
    getClinicCallTemplate();
  }, [getClinicCallTemplate]);

  const generateAudioSample = ()=>{
    setLoading(true)
    templateService.generateAudio(clinicId,templateId)
    .then(res=>{
      toast.success("Generating Audio Sample",{
        position:toast.POSITION.BOTTOM_RIGHT
      })
      setTimeout(()=>{
        getClinicCallTemplate()
        setLoading(false)
      },5000)
    
    })
    .catch(err=>{
      toast.error("Not able to generate Sample",{
        position:toast.POSITION.BOTTOM_RIGHT
      })
      console.log(err)
    })
  }

  const handleCancel = () => {
    navigate("/telephone-template");
  };
  const handleTextAreaChange = (event) => {
    setTxtContent(event.target.value);
  };
  const handleUpdateTemplate = () => {
    const data = {
      id: templateId,
      type: template.type,
      audioPath: txtAudioPath,
      content: txtContent,
      voiceSequence: txtVoiceSequence,
      status: txtStatus,
    };
    templateService
      .updateCallTemplate(clinicId, templateId, data)
      .then((res) => {
        toast.success("Template Saved", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      })
      .catch((err) => {
        toast.error("Error While updating template", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.log(err);
      });
  };
  const handleUpdateVS = (index, updatedVS) => {
    // console.log("handle update ",index,updatedVS)
    const updatedVoiceSquence = [...txtVoiceSequence];
    // console.log(updatedVoiceSquence)
    updatedVoiceSquence[index] = updatedVS;
    //console.log("Updated")

    setTxtVoiceSequence(updatedVoiceSquence);
  };
  const handleDeleteVS = (index) => {
    const updatedVoiceSequence = txtVoiceSequence.filter((_, i) => i !== index);
    setTxtVoiceSequence(updatedVoiceSequence);
  };
  const handleAddVS = () => {
    setTxtVoiceSequence([...txtVoiceSequence, newItem]);
    setNewItem({ type: "Static", content: "", path: null });
  };
  const handleSelectStatusChange = (e) => {
    setTxtStatus(e.target.value);
  };
  return (
    <>
      <div className="container container-xxl">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Eyeconx Telephone Template</h5>

            <div className="row">
              <div className="col-10">
                <span className="card-subtitle">
                  Type : {template && template.type}
                </span>
                <div className="form-group mt-2">
                  <label htmlFor="">Status</label>
                  <select
                    name="selectStatus"
                    id=""
                    onChange={handleSelectStatusChange}
                    className="form-select"
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>

                <div className="form-group mt-2">
                  <label htmlFor="" className="form-label">
                    {" "}
                    Audio Path
                  </label>
                  <div>
                   
                    {loading? <Loading/> :txtAudioPath}
                    <button className="btn btn-sm btn-success ms-2" onClick={generateAudioSample}>
                      Generate
                    </button>
                    {txtAudioPath ? (
                      <>
                        <audio controls>
                          <source src={txtAudioPath} type="audio/mpeg" />
                        </audio>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group mt-2">
                  <label htmlFor="" className="form-label">
                    Content
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows="5"
                    className="form-control"
                    value={txtContent}
                    onChange={handleTextAreaChange}
                  ></textarea>
                </div>
                <div className="mt-2">
                  <label htmlFor="" className="form-label">
                    {" "}
                    Voice Sequence
                  </label>
                  <div className="row p-3">
                    <div className="col-lg-3 col-md-3 label">Type</div>
                    <div className="col-lg-5 col-md-5">Content</div>
                    <div className="col-lg-4 col-md-4">Path</div>
                    <hr />
                    {txtVoiceSequence &&
                      txtVoiceSequence.map((item, index) => {
                        return (
                          <VoiceSequence
                            vsid={index}
                            voiceSequence={item}
                            key={index}
                            handleUpdate={handleUpdateVS}
                            handleDelete={handleDeleteVS}
                          />
                        );
                      })}
                  </div>
                  <button className="btn btn-primary" onClick={handleAddVS}>
                    Add Voice Sequence
                  </button>
                </div>

                <div className="d-flex justify-content-between mt-3"></div>
              </div>
              <div className="col-2">
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-primary btn-sm mb-2"
                    onClick={handleUpdateTemplate}
                  >
                    <i className="bi bi-floppy2"></i> Save Template
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={handleCancel}
                  >
                    <i className="bi bi-x-square"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClinicEditCallTemplate;
